import { useMemo } from 'react';
import { useFormikContext } from 'formik';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { folderDraftForm2ApiMapper } from '../mappers/folder-draft.form2api.mapper';
import type { FolderForm_Folder } from '../fragments/folder.fragment';

export const FolderForm_ActorsStep_CreationAccess_QueryDocument = graphql(`
  query FolderForm_ActorsStep_CreationAccess_Query($folder: FolderInput!) {
    folderCreationAccess(folder: $folder) {
      details {
        fr
      }
    }
  }
`);

// Why the creation of the folder, as the form holds it, will be refused (creating takes the roles
// held through its internal actors); none when it will be allowed, or out of a creation.
export const useFolderCreationRefusal = (
  isCreation: boolean,
): string | null => {
  const { codingStrategiesCodeMap } = useReferencesContext();
  const { values } = useFormikContext<FolderForm_Folder>();

  const folder = useMemo(
    () =>
      folderDraftForm2ApiMapper(
        values,
        codingStrategiesCodeMap.CodingConfigAutomatic._id,
      ),
    [codingStrategiesCodeMap.CodingConfigAutomatic._id, values],
  );

  const { data } = useGraphQLQuery(
    FolderForm_ActorsStep_CreationAccess_QueryDocument,
    { folder },
    { enabled: isCreation },
  );

  const details = data?.folderCreationAccess.details ?? [];

  return details.length ? details.map(({ fr }) => fr).join(' ') : null;
};
